// 微应用的 webpack 配置
// 根据 qiankun 要求更新 dev server
// 目前发现更新后会影响热更新，所以把它放到
const updateMicroAppDevServer = (configChain) => {
  configChain.devServer
    .headers({
      'Access-Control-Allow-Origin': '*',
    })
    .hot(true)
    .historyApiFallback(true)
    .watchContentBase(false);
};

// 根据 qiankun 要求更新 output 内容
const updateMicroAppOutput = (configChain, pkgName) => {
  configChain.output
    .library(`${pkgName}-[name]`)
    .libraryTarget('umd')
    .jsonpFunction(`webpackJsonp_${pkgName}`)
    .globalObject('window');
};

module.exports = {
  updateMicroAppOutput,
  updateMicroAppDevServer,
};
